<script lang="ts">
  import CloseSvg from '$lib/assets/icons/close.svg';
  import { dismissNotification, notifications } from '$lib/stores/client-notifications.store';

  function handleDismiss(id: string) {
    dismissNotification(id);
  }
</script>

{#if $notifications.length > 0}
  <div class="divide-y divide-white/20">
    {#each $notifications as notification (notification.id)}
      <div class="flex items-center justify-center gap-4 bg-[var(--primary-color)] px-4 py-3 text-white">
        <div
          class="flex-1 text-pretty text-center text-[.9375rem] font-normal [&_a:hover]:opacity-90 [&_a]:text-white [&_a]:underline [&_p]:m-0"
        >
          <!-- eslint-disable-next-line svelte/no-at-html-tags -- Safe: hardcoded internal notifications only -->
          {@html notification.message}
        </div>
        <button
          type="button"
          aria-label="Dismiss notification"
          class="flex h-6 w-6 flex-shrink-0 cursor-pointer items-center justify-center border-none bg-transparent p-0 opacity-80 hover:opacity-100"
          onclick={() => handleDismiss(notification.id)}
        >
          <svg viewBox="0 0 24 24" class="h-4 w-4 fill-white">
            <use xlink:href="{CloseSvg}#close" />
          </svg>
        </button>
      </div>
    {/each}
  </div>
{/if}
